import posthog from 'posthog-js';
import { User } from '@supabase/supabase-js';

/**
 * Handles PostHog user identification and reset.
 * Identifies the user with their ID and email if they are not already identified with that ID.
 * Resets PostHog identity if the user is null and a PostHog identity currently exists.
 *
 * @param user The Supabase user object, or null if logged out.
 */
export const handlePostHogIdentity = (user: User | null): void => {
  if (user) {
    // User is logged in or session updated
    if (posthog.get_distinct_id() !== user.id) {
      posthog.identify(user.id, {
        email: user.email,
      });
    }
  } else {
    // User is logged out or session is null
    if (posthog.get_distinct_id()) {
      posthog.reset();
    }
  }
};

/**
 * Captures a custom event with PostHog, automatically including the current URL
 * and parsing a 'returnUrl' query parameter.
 *
 * @param eventName The name of the custom event to capture.
 * @param extraParams Optional parameters, including eventProperties.
 *                  - eventProperties: A dictionary of custom properties for the event.
 */
export const captureCustomEvent = (
  eventName: string,
  extraParams?: { eventProperties?: Record<string, any> }
): void => {
  const properties: Record<string, any> = {
    ...(extraParams?.eventProperties || {})
  };

  // Add returnUrl from query parameters if it exists
  const returnUrlParam = new URLSearchParams(window.location.search).get('returnUrl');
  if (returnUrlParam) {
    properties.return_url = returnUrlParam;
  }

  posthog.capture(eventName, properties);
}; 